import React from 'react';
import CSVSiteValidation from './CSVSiteValidation';
import KMLSiteData from './KMLSiteData';
import type {
  ImportedKmlSite,
  SiteImportFileData,
  SiteImportFileType,
  SiteGroupKind,
  SiteImportSubmitState,
} from './siteImportModalTypes';

type SiteFileDataProps = {
  closeFunc: () => void;
  data: SiteImportFileData;
  fileType: SiteImportFileType;
  groupKind?: SiteGroupKind;
  onSubmitStateChange: (state: SiteImportSubmitState | null) => void;
};

function SiteFileData(props: SiteFileDataProps) {
  const {
    data,
    fileType,
    closeFunc,
    groupKind = 'network_sites',
    onSubmitStateChange,
  } = props;

  if (fileType === 'kml' || fileType === 'kmz') {
    return (
      <KMLSiteData
        data={data as ImportedKmlSite[]}
        groupKind={groupKind}
        closeFunc={closeFunc}
        onSubmitStateChange={onSubmitStateChange}
      ></KMLSiteData>
    );
  } else {
    return (
      <CSVSiteValidation
        skipFirstRow={true}
        data={data as string[][]}
        groupKind={groupKind}
        closeFunc={closeFunc}
        onSubmitStateChange={onSubmitStateChange}
      ></CSVSiteValidation>
    );
  }
}

export default SiteFileData;
